;(function(){
  'use strict';
  var KEY = 'ff_rv';
  var MAX = 10;

  /* ─ Track a product view ─ */
  function track(product) {
    if (!product || !product.id) return;
    var list = getAll();
    list = list.filter(function(p){ return p.id !== product.id; });
    list.unshift(product);
    if (list.length > MAX) list = list.slice(0, MAX);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
  }

  /* ─ Get all viewed products ─ */
  function getAll() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch(e){ return []; }
  }

  /* ─ Money format ─ */
  function money(cents) {
    return '\u00a3' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ─ Render the strip ─ */
  function renderStrip() {
    var container = document.getElementById('ff-rv-strip');
    if (!container) return;
    var list = getAll();
    /* Exclude the current product if we're on a PDP */
    var currentId = container.dataset.currentId;
    if (currentId) list = list.filter(function(p){ return String(p.id) !== String(currentId); });
    if (list.length < 2) { container.style.display = 'none'; return; }
    /* Cap at 6 for the strip */
    list = list.slice(0, 6);
    container.style.display = '';
    var html = '<div class="ff-rv__inner">' +
      '<p class="ff-rv__label">Recently viewed</p>' +
      '<div class="ff-rv__scroll">';
    list.forEach(function(p) {
      html += '<a href="' + p.url + '" class="ff-rv__card">' +
        '<div class="ff-rv__img-wrap">' +
          (p.image ? '<img src="' + p.image + '" alt="' + p.title.replace(/"/g,'&quot;') + '" class="ff-rv__img" loading="lazy" width="160" height="213">' : '') +
        '</div>' +
        '<p class="ff-rv__title">' + p.title + '</p>' +
        '<p class="ff-rv__price">' + money(p.price) + '</p>' +
        '</a>';
    });
    html += '</div></div>';
    container.innerHTML = html;
  }

  /* ─ Expose global API ─ */
  window.FFRecentlyViewed = { track: track, getAll: getAll, render: renderStrip };

  /* ─ Auto-track on PDP ─ */
  var meta = document.getElementById('ff-rv-product-meta');
  if (meta) {
    try {
      var p = JSON.parse(meta.textContent);
      track(p);
    } catch(e){}
  }

  /* ─ Render on DOMContentLoaded ─ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderStrip);
  } else {
    renderStrip();
  }

})();
